import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { GenericObject } from '@fnol/library/src/lib';
import { translations, policiesProperties } from '../../lib/consts';
import './activePoliciesSelect.css';

export const ActivePoliciesSelect = (data: GenericObject) => {
    return (
        <Select name={data.name} id={data.name} onChange={data.onChange} label={data.label} value={data.value}>
            {data.items.map((policy: GenericObject) => {
                const address = `${policy[policiesProperties.address]}, ${policy[policiesProperties.city]}`;
                const validFrom = new Date(policy[policiesProperties.validFrom]);
                const dateFrom = `${validFrom.getDate()}/${validFrom.getMonth() + 1}/${validFrom.getFullYear()}`;
                const validTo = new Date(policy[policiesProperties.validTo]);
                const dateTo = `${validTo.getDate()}/${validTo.getMonth() + 1}/${validTo.getFullYear()}`;
                return (
                    <MenuItem
                        key={policy[policiesProperties.policyNumber]}
                        value={policy[policiesProperties.policyNumber]}
                        style={{ whiteSpace: 'normal' }}
                    >
                        <div>
                            <div>
                                <span style={{ fontWeight: 'bold' }}>{`${translations.POLICY_NUMBER}: `}</span>
                                {policy[policiesProperties.policyNumber]}
                            </div>
                            <div className="hide-when-selected">
                                <span style={{ fontWeight: 'bold' }}>{`${translations.TIME_PERIOD}: `}</span>
                                {`${dateFrom} - ${dateTo}`}
                            </div>
                            <div className="hide-when-selected">
                                <span style={{ fontWeight: 'bold' }}>{`${translations.ADDRESS}: `}</span>
                                {address}
                            </div>
                        </div>
                    </MenuItem>
                );
            })}
        </Select>
    );
};
